export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-[#0b0d14] flex flex-col items-center justify-center gap-6">
      {/* Animated Spinner */}
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-[#1e2235] rounded-full" />
        <div className="absolute inset-0 border-4 border-transparent border-t-blue-500 rounded-full animate-spin" />
      </div>

      {/* Brand */}
      <div className="flex flex-col items-center gap-2">
        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
          <span className="text-white font-bold text-lg">CK</span>
        </div>
        <p className="text-white font-semibold">CollabKare</p>
        <p className="text-gray-400 text-sm">Loading...</p>
      </div>
    </div>
  );
}
